export default "__VITE_ASSET__DOGnCf7i__"